import { DISEASE } from 'utils/constants/disease';

export const NEW_CANCER_TYPES = [
  DISEASE.RCC,
  DISEASE.MESO,
  DISEASE.GENERAL,
  DISEASE.CML,
  DISEASE.SARCOMA,
  DISEASE.CERVICAL,
];
